/*!function(){
  var e={addon:window.themeVariables.settings.addons.smartSearch,settings:window.themeVariables.settings};
  const t={enableSearchByProducts:e.settings.enableSearchByProducts,enableSearchByArticles:e.settings.enableSearchByArticles,enableSearchByPages:e.settings.enableSearchByPages,resultLimit:e.addon.resultLimit};
  let s=[];t.enableSearchByProducts&&s.push("product"),t.enableSearchByArticles&&s.push("article"),t.enableSearchByPages&&s.push("page");
  class i extends HTMLElement{constructor(){super(),this.cachedResults={},this.input=this.querySelector("input[type='search']"),this.predictiveSearchResults=this.querySelector(".custom-faq-smart-search__results"),this.smartSearchSection=this.querySelector(".custom-faq-smart-search"),this.limit=t.resultLimit,this.resourcesType=s.join(","),this.input.setAttribute("autocomplete","off"),this.setupEventListeners()}setupEventListeners(){this.querySelector("form.search-bar").addEventListener("submit",this.onFormSubmit.bind(this)),this.input.addEventListener("input",theme.helpers.debounce(e=>{this.onChange(e)},300).bind(this)),this.input.addEventListener("focus",this.onFocus.bind(this)),this.addEventListener("focusout",this.onFocusOut.bind(this)),this.addEventListener("keyup",this.onKeyup.bind(this)),this.addEventListener("keydown",this.onKeydown.bind(this))}getQuery(){return this.input=this.querySelector("input[type='search']"),this.input.value.trim()}onChange(){var e=document.querySelectorAll("predictive-search input[type='search']"),t=this.getQuery();e.forEach(e=>{e.value=this.input.value}),t.length?this.getSearchResults(t):this.close(!0)}onFormSubmit(e){this.getQuery().length&&!this.querySelector(".item-selected a")||e.preventDefault()}onFocus(){var e=this.getQuery();e.length&&("true"===this.getAttribute("results")?this.open():this.getSearchResults(e))}onFocusOut(){setTimeout(()=>{this.contains(document.activeElement)||this.close()})}onKeyup(e){switch(this.getQuery().length||this.close(!0),e.preventDefault(),e.code){case"ArrowUp":this.switchOption("up");break;case"ArrowDown":this.switchOption("down");break;case"Enter":this.selectOption()}}onKeydown(e){"ArrowUp"!==e.code&&"ArrowDown"!==e.code||e.preventDefault()}switchOption(t){if(this.getAttribute("open")){var s,t="up"===t,i=this.querySelector(".item-selected"),r=Array.from(this.querySelectorAll(".custom-faq-smart-search__item"));let e=r[0];t&&!i||(s=i?r.indexOf(i):0,!t&&i?e=r[s+1]||r[0]:t&&(e=r[s-1]||r[r.length-1]),e!==i&&(e.classList.add("item-selected"),i&&i.classList.remove("item-selected"),this.input.setAttribute("aria-activedescendant",e.id)))}}selectOption(){var e=this.querySelector(".item-selected a, .item-selected button");e&&e.click()}getSearchResults(e){const t=e.replace(" ","-").toLowerCase();this.cachedResults[t]?this.renderSearchResults(this.cachedResults[t]):fetch(`${window.themeVariables.variables.routes.predictiveSearchUrl}?q=${encodeURIComponent(e)}&${encodeURIComponent("resources[type]")}=${this.resourcesType}&${encodeURIComponent("resources[limit]")}=${this.limit}&${encodeURIComponent("resources[options][unavailable_products]")}=last&${encodeURIComponent("resources[options][fields]")}=title,product_type,variants.title,vendor,body&section_id=custom-faq-smart-search`).then(e=>{if(e.ok)return e.text();throw e=new Error(e.status),this.close(),e}).then(e=>{e=(new DOMParser).parseFromString(e,"text/html").querySelector("#shopify-section-custom-faq-smart-search").innerHTML;this.cachedResults[t]=e,this.renderSearchResults(e)}).catch(e=>{throw this.close(),e})}renderSearchResults(e){this.predictiveSearchResults.innerHTML=e,this.updateCurrencies(),this.setAttribute("results",!0),this.open(),theme.helpers.loadComponent("imagesLazyloading",()=>{theme.imagesLazyLoading()})}updateCurrencies(){document.dispatchEvent(new CustomEvent("theme:addon:custom-currencies:convert-prices"))}open(){this.predictiveSearchResults.hidden=!1,this.setAttribute("open","true"),this.input.setAttribute("aria-expanded","true")}close(e=!1){e&&(this.input.value="",this.removeAttribute("results"));e=this.querySelector(".item-selected");e&&e.classList.remove("item-selected"),this.input.setAttribute("aria-activedescendant",""),this.predictiveSearchResults.hidden=!0,this.removeAttribute("open"),this.input.setAttribute("aria-expanded","false")}}customElements.define("predictive-search",i)
}();
*/

!function() {
    var e = {
        addon: window.themeVariables.settings.addons.smartSearch,
        settings: window.themeVariables.settings
    };

    const t = {
        enableSearchByProducts: e.settings.enableSearchByProducts,
        enableSearchByArticles: e.settings.enableSearchByArticles,
        enableSearchByPages: e.settings.enableSearchByPages,
        resultLimit: e.addon.resultLimit
    };

    let s = [];
    t.enableSearchByProducts && s.push("product");
    t.enableSearchByArticles && s.push("article");
    t.enableSearchByPages && s.push("page");

    class i extends HTMLElement {
        constructor() {
            super();
            this.cachedResults = {};
            this.input = this.querySelector("input[type='search']");
            this.predictiveSearchResults = this.querySelector(".custom-faq-smart-search__results");
            this.smartSearchSection = this.querySelector(".custom-faq-smart-search");
            this.limit = t.resultLimit;
            this.resourcesType = s.join(",");
            this.input.setAttribute("autocomplete", "off");
            this.setupEventListeners();
        }

        setupEventListeners() {
            this.querySelector("form.faq-search-bar").addEventListener("submit", this.onFormSubmit.bind(this));
            this.input.addEventListener("input", theme.helpers.debounce(e => {
                this.onChange(e);
            }, 300).bind(this));
            this.input.addEventListener("focus", this.onFocus.bind(this));
            this.addEventListener("focusout", this.onFocusOut.bind(this));
            this.addEventListener("keyup", this.onKeyup.bind(this));
            this.addEventListener("keydown", this.onKeydown.bind(this));
        }

        getQuery() {
            this.input = this.querySelector("input[type='search']");
            return this.input.value.trim();
        }

        onChange() {
            var e = document.querySelectorAll("faq-predictive-search input[type='search']");
            var t = this.getQuery();
            e.forEach(e => {
                e.value = this.input.value;
            });
            t.length ? this.getSearchResults(t) : this.close(!0);
        }

        onFormSubmit(e) {
            this.getQuery().length && !this.querySelector(".item-selected a") || e.preventDefault();
        }

        onFocus() {
            var e = this.getQuery();
            e.length && ("true" === this.getAttribute("results") ? this.open() : this.getSearchResults(e));
        }

        onFocusOut() {
            setTimeout(() => {
                this.contains(document.activeElement) || this.close();
            });
        }

        onKeyup(e) {
            switch (this.getQuery().length || this.close(!0), e.preventDefault(), e.code) {
                case "ArrowUp":
                    this.switchOption("up");
                    break;
                case "ArrowDown":
                    this.switchOption("down");
                    break;
                case "Enter":
                    this.selectOption();
            }
        }

        onKeydown(e) {
            "ArrowUp" !== e.code && "ArrowDown" !== e.code || e.preventDefault();
        }

        switchOption(t) {
            if (this.getAttribute("open")) {
                var s, t = "up" === t;
                var i = this.querySelector(".item-selected");
                var r = Array.from(this.querySelectorAll(".custom-faq-smart-search__item"));
                let e = r[0];
                t && !i || (
                    s = i ? r.indexOf(i) : 0,
                    !t && i ? e = r[s + 1] || r[0] : t && (e = r[s - 1] || r[r.length - 1]),
                    e !== i && (
                        e.classList.add("item-selected"),
                        i && i.classList.remove("item-selected"),
                        this.input.setAttribute("aria-activedescendant", e.id)
                    )
                );
            }
        }

        selectOption() {
            var e = this.querySelector(".item-selected a, .item-selected button");
            e && e.click();
        }

        getSearchResults(e) {
            const t = e.replace(" ", "-").toLowerCase();
            this.cachedResults[t] ? this.renderSearchResults(this.cachedResults[t]) : fetch(
                `${window.themeVariables.variables.routes.predictiveSearchUrl}?q=${encodeURIComponent(e)}&${encodeURIComponent("resources[type]")}=${this.resourcesType}&${encodeURIComponent("resources[limit]")}=${this.limit}&${encodeURIComponent("resources[options][unavailable_products]")}=last&${encodeURIComponent("resources[options][fields]")}=title,product_type,variants.title,vendor,body&section_id=custom-faq-smart-search`
            ).then(e => {
                if (e.ok) return e.text();
                throw e = new Error(e.status), this.close(), e;
            }).then(e => {
                e = (new DOMParser).parseFromString(e, "text/html").querySelector("#shopify-section-custom-faq-smart-search").innerHTML;
                this.cachedResults[t] = e;
                this.renderSearchResults(e);
            }).catch(e => {
                throw this.close(), e;
            });
        }

        renderSearchResults(e) {
            this.predictiveSearchResults.innerHTML = e;
            this.updateCurrencies();
            this.setAttribute("results", !0);
            this.open();
            theme.helpers.loadComponent("imagesLazyloading", () => {
                theme.imagesLazyLoading();
            });
        }

        updateCurrencies() {
            document.dispatchEvent(new CustomEvent("theme:addon:custom-currencies:convert-prices"));
        }

        open() {
            this.predictiveSearchResults.hidden = !1;
            this.setAttribute("open", "true");
            this.input.setAttribute("aria-expanded", "true");
        }

        close(e = !1) {
            e && (this.input.value = "", this.removeAttribute("results"));
            e = this.querySelector(".item-selected");
            e && e.classList.remove("item-selected");
            this.input.setAttribute("aria-activedescendant", "");
            this.predictiveSearchResults.hidden = !0;
            this.removeAttribute("open");
            this.input.setAttribute("aria-expanded", "false");
        }
    }

    customElements.define("faq-predictive-search", i);
}();
